import axios from 'apis/axios';
import Axios from 'axios';
import jwt_decode from 'jwt-decode';
import toast from 'react-hot-toast';
import { userActionType } from './user.action.type';
import store from '../store'
import { setCurrentUser } from './userSlice';

// export const setCurrentUser = (user) => ({
//   type: userActionType.SET_CURRENT_USER,
//   payload: user,
// });

/** Same persistence + full reload as after normal login (axios reads token from localStorage on next load). */
const persistSessionAndReload = (dispatch, token, user, redirectUrl) => {
  dispatch(setCurrentUser({ token, ...user }));
  localStorage.setItem('user', JSON.stringify({ token, ...user }));
  localStorage.setItem('token', token);
  window.dispatchEvent(new Event('storage'));
  window.location.href = redirectUrl ? redirectUrl : '';
};

/**
 * Same shapes as POST user/login: flat { token, user } or nested { data: { token, user } }.
 * `body` must be the axios response body (not the full axios response).
 */
const extractLoginSession = (body) => {
  if (!body || typeof body !== 'object') return null;
  const nested =
    body.data && typeof body.data === 'object' && (body.data.token || body.data.user)
      ? body.data
      : null;
  const token = nested?.token ?? body.token;
  let user = nested?.user ?? body.user;
  if (!token) return null;
  if (!user) {
    try {
      const decoded = jwt_decode(token);
      if (decoded && typeof decoded === 'object' && decoded._id) {
        const { exp, iat, nbf, ...userFromJwt } = decoded;
        user = userFromJwt;
      }
    } catch {
      /* ignore */
    }
  }
  if (!user) return null;
  return { token, user };
};

/**
 * When the IdP puts an app JWT in the URL (same shape as post-login token), hydrate session without an API round-trip.
 * Returns true if a session was applied.
 */
const tryApplyAppJwtFromUrlToken = (rawToken, dispatch, redirectUrl) => {
  const parts = rawToken.split('.');
  if (parts.length !== 3) return false;
  try {
    const decoded = jwt_decode(rawToken);
    if (!decoded || typeof decoded !== 'object' || !decoded._id) return false;
    const { exp, iat, nbf, ...userFromJwt } = decoded;
    persistSessionAndReload(dispatch, rawToken, userFromJwt, redirectUrl);
    return true;
  } catch {
    return false;
  }
};

/**
 * CyberArk (or other SAML) redirect: `?token=...` exchanged for an app session via backend, same response shape as `user/login`.
 * Uses a plain Axios call so the request is not tied to any stale Authorization header from `apis/axios`.
 * Optional env: REACT_APP_CYBERARK_LOGIN_PATH (default `user/cyberark-login`).
 * If the exchange response is unusable or the route errors, falls back to treating the URL value as an app JWT with `_id` in the payload.
 */
export const loginWithCyberArkUrlToken =
  (rawToken, redirectUrl, setIsLoading) => async (dispatch) => {
    setIsLoading?.(true);
    const trimmed = (rawToken || '').trim();
    if (!trimmed) {
      setIsLoading?.(false);
      return;
    }

    const path = process.env.REACT_APP_CYBERARK_LOGIN_PATH || 'user/cyberark-login';
    const base = process.env.REACT_APP_API_URL || '';

    try {
      const { data: body } = await Axios.post(
        `${base}${path}`,
        { token: trimmed },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const session = extractLoginSession(body);
      if (session) {
        persistSessionAndReload(dispatch, session.token, session.user, redirectUrl);
        return true;
      }
      if (tryApplyAppJwtFromUrlToken(trimmed, dispatch, redirectUrl)) {
        setIsLoading?.(false);
        return true;
      }
      throw new Error('Invalid response from sign-in service');
    } catch (err) {
      if (tryApplyAppJwtFromUrlToken(trimmed, dispatch, redirectUrl)) {
        setIsLoading?.(false);
        return true;
      }
      setIsLoading?.(false);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'CyberArk sign-in failed';
      toast.error(msg);
      return false;
    }
  };

export const loginUser = (user, navigate, source, setIsLoading) => async (dispatch) => {
  setIsLoading(true);

  const myPromise = axios({
    method: 'post',
    data: {
      ...user,
    },
    url: `user/login`,
  });
  toast.promise(myPromise, {
    loading: 'Loading',
    success: (response) => {
      const session = extractLoginSession(response.data);
      if (!session) {
        setIsLoading(false);
        return 'Invalid login response';
      }
      persistSessionAndReload(dispatch, session.token, session.user, source);
      console.log({source})
      setIsLoading(false);
      return response.data?.message ?? response.data?.data?.message ?? 'Logged in';
    },
    error: (err) => {
      setIsLoading(false);
      console.log(err);
      const data = err.response?.data;
      // Password expired: hand the one-time token + userId to the change-password screen.
      if (data?.isPasswordExpired && data?.token && data?.userId) {
        navigate('/change-password', {
          state: { token: data.token, userId: data.userId },
        });
        return (
          data.message || 'Your password has expired. Please set a new password to continue.'
        );
      }
      return err.response ?  err.response.data.message : err.message ||
      'Something went wrong'
    }
  });
};

export const logOutUser = (navigate) => async (dispatch) => {
  const user = store.getState().user?.currentUser
  // const myPromise = axios({
  //   method: 'put',
  //   data: {
  //     isLoggedInFromAdminPortal: false,
  //   },
  //   url: `user/` + ((user?._id) ? user._id : "logout")
  // });
  // toast.promise(myPromise, {
  //   loading: 'Loading',
  //   success: (data) => {
  //     dispatch(setCurrentUser(null));
  //     localStorage.clear();
  //     // console.log("logout", localStorage.getItem("user"))
  //     window.dispatchEvent(new Event("clearStorage"));
  //     navigate("/login")
  //     return 'Successfully Logged out';
    
  //   },
  //   error: (err) =>
  //     err.response.data.error ||
  //     err.response.data.message ||
  //     err.message ||
  //     'Something went wrong',
  // });
  dispatch(setCurrentUser(null));
  localStorage.clear();
  window.dispatchEvent(new Event("clearStorage"));
  navigate("/login")
  return 'Successfully Logged out';

};